import { IUserAlternativeTemplate } from "@/types/event-template-alternative-user";
import { BaseService } from "./BaseService";
import axiosInstance from "@/lib/axios";
import { AxiosResponse } from "axios";

export interface ActivationRequest {
  activationCode: string;
  telegramChatId: number;
}

export interface ActivationResponse {
  accessToken: string;
  refreshToken: string;
  message: string;
}

export interface StatusResponse extends ActivationResponse {
  eventTemplateAlternativeUser: IUserAlternativeTemplate;
}

class AuthService extends BaseService {
  constructor() {
    super("/api/self/auth");
  }

  async activate(data: ActivationRequest) {
    const response = await axiosInstance
      .post(`${this.endpoint}/activate-telegram-group`, data)
      .then((res) => res.data);

    if (response.data.accessToken) {
      this.saveInfo({ ...response.data, telegramChatId: data.telegramChatId });
    }

    return response.data;
  }

  async checkStatus(chatId: number) {
    const response = await axiosInstance.post<AxiosResponse<StatusResponse>>(
      `${this.endpoint}/verify-telegram-activation`,
      {
        telegramChatId: chatId,
      },
    );
    if (response.data.data) {
      this.saveInfo({ ...response.data.data, telegramChatId: chatId });
    }
    return response.data.data;
  }

  async logout(): Promise<void> {
    localStorage.removeItem("authToken");
  }

  saveInfo(data: ActivationResponse & { telegramChatId?: number }) {
    localStorage.setItem("authToken", data.accessToken);
    localStorage.setItem(
      "telegramChatId",
      (data.telegramChatId || 0)?.toString(),
    );
    localStorage.setItem("refreshToken", data.refreshToken);
  }

  isAuthenticated(): boolean {
    return !!localStorage.getItem("authToken");
  }
}

export const authService = new AuthService();
